import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { id: "uvod", label: "Úvod" },
    { id: "o-vinarstvi", label: "O vinařství" },
    { id: "vina", label: "Vína" },
    { id: "degustace", label: "Degustace" },
    { id: "galerie", label: "Galerie" },
    { id: "ubytovani", label: "Ubytování" },
    { id: "kontakt", label: "Kontakt" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "glass-nav" : "bg-transparent"}`}
        >
            <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-5 flex items-center justify-between">
                <button
                    data-testid="logo-button"
                    onClick={() => go("uvod")}
                    className="flex items-center group"
                    aria-label="Vinařství Štrokay"
                >
                    <img
                        src="https://i.ibb.co/67G6vkDf/Chat-GPT-Image-31-7-2026-19-20-43.png"
                        alt="Vinařství Štrokay"
                        className="h-24 md:h-28 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.04]"
                    />
                </button>

                <nav className="hidden lg:flex items-center gap-9">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="text-sm font-medium text-ink/85 hover:text-burgundy transition-colors duration-200 relative group"
                        >
                            {l.label}
                            <span className="absolute left-0 -bottom-1 w-0 h-px bg-burgundy transition-all duration-300 group-hover:w-full"></span>
                        </button>
                    ))}
                </nav>

                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    className="lg:hidden p-2 text-ink"
                    aria-label="menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden glass-nav border-t border-ink/10" data-testid="mobile-menu">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`mobile-nav-${l.id}`}
                                onClick={() => go(l.id)}
                                className="text-left font-serif text-2xl text-ink hover:text-burgundy transition-colors"
                            >
                                {l.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
